import * as React from "react";

const PreviousPage: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="12" viewBox="0 0 7 12" fill="none">
            <path
                d="M5.97969 11.6601L0.319687 6.00009L5.97969 0.340088L6.67969 1.05009L1.72969 6.00009L6.67969 10.9501L5.97969 11.6601Z"
                fill="#535353"
            />
        </svg>
    );
};

export default React.memo(PreviousPage);
